import React from 'react';

const Alert = ({type = 'info', dismissable = false, children}) => {
  if (!['success', 'error', 'warning', 'info'].includes(type)) {
    throw new Error('invalid type ' + type);
  }
  let alertClass = `alert alert-{tpye}`;
  let closeButton = null;
  if (dismissable) {
    alertClass += ' alert-dismissable';
    closeButton = (<a href="#" class="close" data-dismiss="alert" aria-label="close">&times;</a>);
  }
  return (
    <div className={ alertClass } >
      { closeButton }
      { children }
    </div>
  );
};

export default Alert;



// WEBPACK FOOTER //
// ../hyperdb-utils/src/components/ui-react/Alert.jsx